import { coerceCurrency, formatCurrency } from '@/lib/format';

/** The subset of a recovery-edit event this helper needs (INP-522). */
export interface RecoveryEditLike {
  actor_alias: string | null;
  from_amount: string | null;
  to_amount: string | null;
}

/** A one-line, practitioner-facing description of one recovery-amount edit:
 *  "brian set $500.00 (was $999.99)" or "brian reset to the engine's amount".
 *  Pure so the wording is unit-tested; `actor_alias` null reads as "system". */
export function describeRecoveryEdit(event: RecoveryEditLike, currency: string): string {
  const actor = event.actor_alias ?? 'system';
  const cur = coerceCurrency(currency);
  if (event.to_amount === null) {
    return `${actor} reset to the engine's amount`;
  }
  const to = formatCurrency(event.to_amount, cur);
  const was =
    event.from_amount !== null ? ` (was ${formatCurrency(event.from_amount, cur)})` : '';
  return `${actor} set ${to}${was}`;
}
